import React, { Component } from 'react';
import { Flex, Heading, Text, Link, Button, Card } from 'core/components';
import Markdown from '../../journeys/Markdown';

class WebSearchToolResult extends Component {
  render() {
    const { tool, onCloseToolResult, isInlineMode = false } = this.props;
    const { raw_result = {} } = tool;
    const { query, answer, results = [], response_time } = raw_result;

    return (
      <Card
        p={0}
        className="tool-result-web-search"
        display="flex"
        flexDirection="column"
        minHeight={isInlineMode ? 400 : 600}
        maxHeight={isInlineMode ? 500 : undefined}
        gap={2}
        overflow="auto"
      >
        <Flex alignItems="center" justifyContent="space-between" p={2} pb={0}>
          <Heading level={isInlineMode ? 6 : 5} m={0} flex={1}>
            {tool.title || 'Web Search Tool Result'}
          </Heading>
          <Flex alignItems="center" gap={1}>
            <Button text="Close" small icon="cross" onClick={() => onCloseToolResult(tool)} color="muted" minimal />
          </Flex>
        </Flex>
        <Flex flexDirection="column" px={2}>
          <Text fontWeight="bold" mb={1}>
            {query}
          </Text>
          <Text mb={1}>{answer}</Text>
          {results && results.length > 0 && (
            <>
              <Text fontWeight="bold" mb={1}>
                Sources
              </Text>
              <Flex flexDirection="column" gap={2}>
                {results.map((item) => (
                  <Flex key={item.url} flexDirection="column">
                    <Link to={item.url} blank>
                      {item.title}
                    </Link>
                    {item.published_date && (
                      <Text muted small>
                        Published: {item.published_date}
                      </Text>
                    )}
                    <Markdown>{item.content}</Markdown>
                    {typeof item.score === 'number' && <Text muted>Relevance: {(item.score * 100).toFixed(1)}%</Text>}
                  </Flex>
                ))}
              </Flex>
            </>
          )}
          <Text mt={3} fontSize={0} color="muted">
            Response time: {response_time}s
          </Text>
        </Flex>
      </Card>
    );
  }
}

export default WebSearchToolResult;
